import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types
import { SnackbarProps } from 'types/snackbar';

const initialState: SnackbarProps = {
    open: false,
    title: '',
    subtitle: '',
    type: 'success'
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const snackbar = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        openSnackbar(state, action: PayloadAction<SnackbarProps>) {
            const { open, title, subtitle, type, cta, close, cy } = action.payload;
            state.open = open;
            state.title = title;
            state.subtitle = subtitle;
            state.type = type;
            state.cta = cta;
            state.close = close;
            state.cy = cy;
        },

        closeSnackbar(state) {
            state.open = false;
        }
    }
});

export default snackbar.reducer;

export const { closeSnackbar, openSnackbar } = snackbar.actions;
